import DeleteIcon from '@mui/icons-material/Delete';
import { FormattedMessage } from 'react-intl';
import RowMenuItem from '../../DataGrid/RowMenuItem';
import messages from '../messages';

interface IDeleteDeviceProps {
  deviceId: number | string;
  deviceType: string;
  onOpenModal: (deviceType: string, deviceId: number | string) => void;
}

const DeleteDevice = ({ deviceId, deviceType, onOpenModal }: IDeleteDeviceProps) => (
  <RowMenuItem
    dataTestId="device-delete-device"
    colorIcon="error.dark"
    colorText="error.dark"
    icon={<DeleteIcon />}
    label={<FormattedMessage {...messages.deviceDataGridActionDeviceRowMenuDeleteDevice} />}
    onClick={() => onOpenModal(deviceType, deviceId)}
  />
);

export default DeleteDevice;
